<template>
  <div class="statistics_main">
    <div class="left">
      <div class="total">总计缺勤：{{total}}</div>
      <el-table size="mini" :data="data" stripe border :loading="isLoading">
        <el-table-column width="80" align="center">
          <template slot-scope="{row}">
            <el-link class="btn_grade" @click="$emit('to-class', row)">{{row.Grade}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="缺勤人数" prop="DtsCount" />
        <el-table-column label="正常缺勤" prop="NormalCount" />
        <el-table-column label="异常缺勤" prop="UnNormalCount" />
      </el-table>
    </div>
    <div class="right">
      <div style="height: 35px;position: relative;">
        <span class="tip">与上一节次比较后的变动情况：</span>
      </div>
      <el-table size="mini" :data="data" stripe border :loading="isLoading">
        <el-table-column prop="Grade" width="80" align="center" />
        <el-table-column label="缺勤人数" prop="LastCount">
          <template slot-scope="{row}">
            <span>{{row.LastCount}}</span>
            <template v-if="row.IncreaseCount>0">
              <el-tag size="mini" class="row_tag" type="danger">增加{{row.IncreaseCount}}</el-tag>
            </template>
            <template v-if="row.DecreaseCount>0">
              <el-tag size="mini" class="row_tag" type="warning">减少{{row.DecreaseCount}}</el-tag>
            </template>
            <template v-if="row.ChangeCount>0">
              <el-tag size="mini" class="row_tag">变换{{row.ChangeCount}}</el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="正常缺勤">
          <template slot-scope="{row}">
            <span>{{row.LastNormalCount}}</span>
            <template v-if="row.IncreaseNormalCount>0">
              <el-tag size="mini" class="row_tag" type="danger">增加{{row.IncreaseNormalCount}}</el-tag>
            </template>
            <template v-if="row.DecreaseNormalCount>0">
              <el-tag size="mini" class="row_tag" type="warning">减少{{row.DecreaseNormalCount}}</el-tag>
            </template>
            <template v-if="row.ChangeNormalCount>0">
              <el-tag size="mini" class="row_tag">变换{{row.ChangeNormalCount}}</el-tag>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="异常缺勤">
          <template slot-scope="{row}">
            <span>{{row.LastUnNormalCount}}</span>
            <template v-if="row.IncreaseUnNormalCount>0">
              <el-tag size="mini" class="row_tag" type="danger">增加{{row.IncreaseUnNormalCount}}</el-tag>
            </template>
            <template v-if="row.DecreaseUnNormalCount>0">
              <el-tag size="mini" class="row_tag" type="warning">减少{{row.DecreaseUnNormalCount}}</el-tag>
            </template>
            <template v-if="row.ChangeUnNormalCount>0">
              <el-tag size="mini" class="row_tag">变换{{row.ChangeUnNormalCount}}</el-tag>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      api: require("@/api/at/attendance").default,
      data: [],
      total: 0,
      isLoading: false,
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {},
  methods: {
    query(params) {
      params = this.$commonJs.obj.removeNullKey(params);
      this.api.getStat1V2(params).then((res) => {
        this.clear();
        if (res.Data.length > 0) {
          this.data = res.Data;
          this.total = this.data
            .map((x) => x.DtsCount)
            .reduce((total, num) => {
              return total + num;
            });
          console.log("this.data", this.data);
        }
      });
    },
    clear() {
      this.data = [];
      this.total = 0;
    },
  },
};
</script>
<style lang="scss">
.statistics_main {
  @media screen and (min-width: 768px) {
    display: flex;
    display: -webkit-flex;
  }
  .row_tag {
    float: right;
    margin-left: 5px;
    min-width: 45px;
    text-align: center;
    @media screen and (max-width: 767px) {
      min-width: 45px !important;
    }
  }
  .btn_grade {
    font-size: 12px;
  }
  .left {
    width: 50%;
    @media screen and (max-width: 767px) {
      width: 95% !important;
      margin-left: 10px;
    }
    margin-right: 10px;
    .total {
      line-height: 30px;
      font-size: 14px;
      color: #9a422e;
      margin-bottom: 5px;
    }
  }
  .right {
    width: 50%;
    @media screen and (max-width: 767px) {
      width: 95% !important;
    }
    margin-left: 10px;
    margin-right: 1px;
    .tip {
      font-size: 14px;
      position: absolute;
      bottom: 10px;
      color: #484848;
    }
  }
}
</style>